import { useEffect, useState } from 'react';
import { apiJson } from '../api';
import type { ExplicitProfile } from './whyPersonalization';

type MeProfileRes = {
  profile?: {
    explicit?: ExplicitProfile;
  };
};

export function useMeProfile() {
  const [explicit, setExplicit] = useState<ExplicitProfile | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiJson<MeProfileRes>('/api/me/profile');
        if (cancelled) return;
        setExplicit(res.profile?.explicit ?? null);
        setError(null);
      } catch (e) {
        if (cancelled) return;
        setExplicit(null);
        setError(e instanceof Error ? e.message : 'Failed to load profile');
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { explicit, loaded, error };
}

